//Caching these to save the tiniest fraction of a second
const objectKeys = Object.keys;
const ArrayConstructor = Array;

//If the JSON objects within the array are the same BUT are re-arranged order, then jsonEquals would be false

//Doing a function declaration instead of an arrow function for potentially slightly better performance
function jsonEquals(a, b) {
    if (a === b) { return true; } //If they're the same object in memory, or a string (or other data type) of equal values
    //If a is undefined and b is null then we treat that as not equals
    if (typeof b !== 'object' || typeof a !== 'object' || !a || !b) { return false; } //At this stage, if one is null, undefined, or not an array/object, then they are not equal
    return jsonEqualsInner(a, b);
}

//Skips the checks that were already done
//For performance throughout, not doing for (i in x) or for (i of x), and not even the faster for (let i = 0; i < a.length; i++) { but instead the fastest let i = a.length; and while (i--) { }
function jsonEqualsInner(a, b) {
    const aConstructor = a.constructor;
    if (aConstructor !== b.constructor) { return false; } //if one is an array and the other is a plain object then they are not equal, very important

    let i, aKeyValue, bKeyValue, key, aKeys; //supposedly putting all the declarations at the top is faster

    //Since we already checked a.constructor !== b.constructor then we don't have to worry about this false positive when a = [123] and b = {"0": 123, "length": 1}
    if (aConstructor === ArrayConstructor) {
        i = a.length; //So we don't have to keep checking the length of a
        if (i !== b.length) { return false; }
        while (i--) { //saves a tiny fraction of a second and less CPU intensive
            //for (let i = 0; i < a.length; i++) { //More readable alternative
            aKeyValue = a[i];
            bKeyValue = b[i];
            if (aKeyValue === bKeyValue) { continue; } //faster than doing the recursive call if they're equal, so for primative types this is faster to have this line, but for objects (that are not the same object in memory) we'd need to do the recursive call anyways, safe and possible to comment this line out
            if (typeof bKeyValue !== 'object' || typeof aKeyValue !== 'object' || !aKeyValue || !bKeyValue) { return false; } //Does these checks before doing a recursive call
            if (!jsonEqualsInner(aKeyValue, bKeyValue)) { return false; } //recursive
        }
        return true;
    }

    aKeys = objectKeys(a);
    i = aKeys.length;
    if (i !== objectKeys(b).length) { return false; } //If they have a different number of keys, then they're obviously not equal since we are not caring about undefined values, so these will be treated as not equals a = {"abc": 123, "def": undefined} and b = {"abc" 123}
    while (i--) { //saves a tiny fraction of a second and less CPU intensive
        key = aKeys[i];
        aKeyValue = a[key];
        bKeyValue = b[key];
        if (aKeyValue === bKeyValue) { continue; } //That means they are a primitive type too (or same object in memory)
        if (typeof bKeyValue !== 'object' || typeof aKeyValue !== 'object' || !aKeyValue || !bKeyValue) { return false; } //Does these checks before doing a recursive call
        if (!jsonEqualsInner(aKeyValue, bKeyValue)) { return false; }

        //Alternative ways of checking
        //if (!Object.prototype.hasOwnProperty.call(b, key)) { return false; } //Checks to see if b has the key, if not then they aren't equal
        //if (!Object.hasOwn(b, key)) { return false; } //The simpler way of writing it BUT it requires newer browser releases from after 2021.
        //if (b[key] === undefined && !(key in b)) { return false; } //This is better, it only does the slightly slower key in b check if b[key] is undefined
        //if (!(key in b) || !jsonEqualsInner(a[key], b[key])) { return false; }  //If b doesn't have the key then false, otherwise recursively checks the values
        /* //This is better if we want to treat these as not equals a = {"abc": 123, "def": undefined} and b = {"abc" 123}
        const aKeyValue = a[key];
        const bKeyValue = b[key];
        if (bKeyValue === undefined) {
          if (aKeyValue !== undefined || !(key in b)) { return false; } //If the value in a isn't undefined but b's is, then false, and it also checks to if the key isn't even present in b,  || !(key in b) can be removed if we don't care for that
        } else if (valA === valB) {
          continue;
        } else if (!jsonEqualsInner(aKeyValue, bKeyValue)) {
          return false;
        }
        */
    }

    return true;
}

//console.log(jsonEquals({"abc": {"test": "There"}}, {"abc": "blah"}));
//console.log(jsonEquals([123], [123,4]));

export default jsonEquals;